import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { CasProfileApi, getUser, ReferralApi } from "@jti/rest-api";
import { useSelector } from "@jti/store";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { NavBar, SignOut, useConfig } from "@jti/ui";
import { ConditionalView } from "../../components/conditional-view/ConditionalView";
import { ResponsiveContainer } from "../../components/responsive-container/ResponsiveContainer";
import redirectToAuthPage from "../../helpers/functions/redirectToAuthPage";
import useLoggedUser from "../../helpers/hooks/useLoggedUser";
import GeneralLayout from "../general/GeneralLayout";
import "./accountLayout.scss";
const AccountLayout = ({ children, isInEditor }) => {
    const [isRasActive, setRasActive] = useState(false);
    const [isLogged] = useLoggedUser();
    const { isLoaded } = useSelector((store) => store.loyaltyCore);
    const config = useConfig();
    const onLogout = useCallback(async () => {
        try {
            const user = getUser();
            dispatchTrackingEvent(TrackingEvents.TrackingLogoutSuccess, { user_id: user.uuid || "no id" });
            await CasProfileApi.init().logout();
            redirectToAuthPage(config);
            return true;
        }
        catch (error) {
            console.error("Logout error:", error);
            return false;
        }
    }, []);
    useEffect(() => {
        const fetchReferralStatus = async () => {
            try {
                const status = await ReferralApi.init().getStatus();
                setRasActive(status);
            }
            catch (error) {
                // TODO
                console.error("Error fetching referral status:", error);
            }
        };
        fetchReferralStatus();
    }, []);
    if (isLoaded && !isLogged && !isInEditor) {
        redirectToAuthPage(config);
    }
    return (_jsx(GeneralLayout, { isInEditor: isInEditor, children: _jsx(ResponsiveContainer, { children: _jsx(ConditionalView, { condition: (isLoaded && isLogged) || isInEditor, children: _jsxs("div", { className: "account-layout", children: [_jsxs("div", { className: "account-layout__menu", children: [_jsx(NavBar, { isRasActive: isRasActive, hasLoyalty: true, isExternal: true }), _jsx("div", { className: "account-layout__sign-out", children: _jsx(SignOut, { logout: onLogout, type: "secondary" }) })] }), _jsx("div", { className: "account-layout__content", children: children })] }) }) }) }));
};
export default AccountLayout;
//# sourceMappingURL=AccountLayout.js.map